export const relationshipEnumMap = {
  FATHER: "Father",
  MOTHER: "Mother",
  "FATHER-IN-LAW": "Father-in-law",
  "MOTHER-IN-LAW": "Mother-in-law",
  SPOUSE: "Spouse",
  BROTHER: "Brother",
  SISTER: "Sister",
  SON: "Son",
  "SON-IN-LAW": "Son-in-law",
  DAUGHTER: "Daughter",
  "DAUGHTER-IN-LAW": "Daughter-in-law",
  GRANDSON: "Grandson",
  GRANDDAUGHTER: "Granddaughter",
  DOCTOR: "Doctor",
  SOCIAL_WORKER: "Social Worker",
  DISCHARGE_PLANNER: "Discharge Planner",
  GERIATRIC_CARE_MANAGER: "Geriatric Care Manager (GCM)",
  NURSE: "Nurse",
  FRIEND: "Friend",
  NEIGHBOR: "Neighbor",
  INSURANCE_COMPANY: "Insurance Company",
  OTHER: "Other",
};
export const contactLabels = {
  contactFirstName: "First Name",
  contactLastName: "Last Name",
  contactRelationship: "Relationship",
  contactRoles: "Contact Roles",
  contactPhoneNumber: "Phone Number",
  contactEmail: "Contact Email",
  facilityAddress: "Address",
  city: "City",
  state: "State",
  zipCode: "ZIP Code",
};
export const contactRolesEnumMap = {
  primary: "Primary Contact",
  emergency: "Emergency Contact",
  medical: "Medical Power of Attorney",
  payer: "Payer",
};
export const mobilityDeviceEnumMap = {
  none: "None",
  wheelchair: "Wheelchair",
  walker: "Walker",
  cane: "Cane",
  crutches: "Crutches",
  guideDog: "Guide dog",
  both: "Both Walker & Cane",
};
export const vehicleEnumMap = {
  caregiver: "Caregiver's Vehicle",
  client: "Client's Vehicle",
  either: "Either Vehicle",
  none: "No Vehicle Required",
};

export const paymentCategoryEnumMap = {
  basic: "Basic Care",
  intermediate: "Intermediate Care",
  complex: "Complex Care",
};

export const paymentMethodEnumMap = {
  credit: "Credit Card",
  bank: "ACH Transfer (Recommended)",
};
export const billingRecipientTypeEnumMap = {
  client: "Client",
  authorizedContact: "Other",
};

export const paymentServiceEnumMap = {
  personal: "Personal Care",
  couple: "Couple Care (Please complete document for both individuals)",
  companion: "Companion Care",
  skilled: "Skilled Care (LVN, RN, EMT-P)",
};

export const paymentTermsAndAgreement = {
  description:
    "I (we) have given this authority to Cambridge Caregivers to charge the card on file or to bank draft my (our) account for the payment of my (our) biweekly invoice. I (we) understand this authority shall remain in full force and effect until written notification of termination is received from me (us) and Cambridge Caregivers and the banking institution have a reasonable opportunity to act upon it. I (we) understand that nothing contained in this Authorization shall serve to reduce my (our) obligation to pay my (our) invoice and services may be discontinued should I (we) fail to have sufficient funds in the above referenced credit card or account to cover the amount of the bill.",
  bankTermsAndCondition:
    "I hereby authorize Cambridge Caregivers, LLC to draw upon the above account for payment of obligations owed by Client under this Agreement, I authorize the above Depository Bank to approve transfers initiated by Cambridge Caregivers, LLC for payment on behalf of Client, and I agree to execute any additional documents as may be required by the Depository Bank for such authorization.",
  creditTermsAndCondition:
    "I acknowledge that I will pay a 5% recurring fee for using a credit card",
};

export const serviceLabels = {
  bathing: "Bathing",
  eating: "Eating",
  assistanceEatingNotes: "Assistance Eating Notes",
  toileting: "Toileting",
  mealPreparation: "Meal Preparation",
  dressingGrooming: "Dressing & Grooming",
  housework: "Light Housekeeping",
  companionship: "Companionship",
  transportationNeeded: "Transportation Needed",
  vehiclePreference: "Vehicle Preference",
  other: "Other",
  specifyOther: "Specify Other",
};

export const billingInfoLabels = {
  recipientType: "Recipient Type",
  billingContactFirstName: "Billing Recipient First Name",
  billingContactLastName: "Billing Recipient Last Name",
  billingContactPhone: "Billing Recipient Phone",
  billingContactEmail: "Billing Recipient Email",
  billingStreetAddress: "Street Address",
  billingCity: "City",
  billingState: "State",
  billingZipCode: "Zip Code",
  sendMethod: "How should bills be sent?",
};

export const additionalInformationLabels = {
  petsPresent: "Pets Present",
  petDetails: "Pet Detail",
  smokingEnvironment: "Smoking Environment",
  longTermCareInsurance: "Long Term Care Insurance",
  policyNumber: "Policy Number",
  ltcInsuranceProvider: "Insurance Provider",
  ltcInsuranceAcknowledgment: "LTC Policy Acknowledgment",
  firearmsPresent: "Firearms Present",
  firearmsSecure: "Are Firearms Stored Securely?",
  allergies: "Allergies",
  allergiesNote: "Allergies Note",
  learnMore: "Learn More about LTC Insurance",
};

export const clientCareNeedLabel = {
  medicalDiagnosis: "Medical Diagnosis, recent hospitalizations, or injuries",
  fallRisk: "Fall Risk",
  continence: "Continence",
  vision: "Vision",
  hearing: "Hearing",
  speech: "Speech",
  oxygenDependent: "Oxygen Dependent",
  isShoweringAssistance: "Is showering assistance required?",
  isShoweringAssistanceLevel: "What level of showering assistance is required?",
  isMedicationReminders: "Are medication reminders required?",
  isMedicationRemindersResponse: "Who is currently responsible?",
  isOralHygieneAssistance: "Is oral hygiene assistance required?",
  walker: "Uses walker or cane",
  isMealtimeAssistance: "Is mealtime assistance required?",
  isMealtimeAssistanceLevel: "What level of mealtime assistance is required?",
  swallowing: "Swallowing",
  swallowingOther: "Please specify other",
  dental: "Dental",
};

export const behaviorLabels = {
  confusion: "Confusion",
  confusionNotes: "Confusion Notes",
  agitation: "Agitation",
  agitationNotes: "Agitation Notes",
  suspicious: "Suspicious",
  suspiciousNotes: "Suspicious Notes",
  upAtNight: "Up at Night",
  upAtNightNotes: "Up at Night Notes",
  withdrawn: "Withdrawn",
  withdrawnNotes: "Withdrawn Notes",
  wanders: "Wanders",
  wandersNotes: "Wanders Notes",
  combative: "Combative",
  combativeNotes: "Combative Notes",
};

export const behaviourNoteMapping = {
  confusionNotes: "confusion",
  agitationNotes: "agitation",
  suspiciousNotes: "suspicious",
  upAtNightNotes: "upAtNight",
  withdrawnNotes: "withdrawn",
  wandersNotes: "wanders",
  combativeNotes: "combative",
};

export const allergies = [
  "ACE Inhibitors",
  "Aciphex",
  "Actonel",
  "Actos",
  "Adhesive Tape",
  "Albuterol",
  "Allegra",
  "Allopurinol",
  "Almonds",
  "Amantadine",
  "Amides",
  "Amiodarone",
  "Amoxicillin",
  "Ampicillin",
  "Anectine",
  "Antiemtics",
  "Antihistamines",
  "Aricept",
  "Aspartame",
  "Aspirin (ASA or Salicylates)",
  "Atenolol",
  "Augmentin",
  "Bacitracin",
  "Bactrim",
  "Bananas",
  "Barbituates",
  "Bee Stings",
  "Benadryl",
  "Beta-Adrenergic Blockers",
  "Bisphosphonates",
  "Bleach",
  "Carbapenem",
  "Cashews",
  "Cataflam",
  "Cats",
  "Ceclor",
  "Cefepime",
  "Celebrex",
  "Cephalosporins",
  "Chocolate",
  "Cinnamon",
  "Ciprofloxin",
  "Citalopram",
  "Clarithromycin",
  "Cleaning Products",
  "Clindamycin",
  "Codeine",
  "Colchicine",
  "Compazine",
  "Corn",
  "Corticosteroids",
  "Coumadin",
  "Crabmeat",
  "Creatine Monohydrate",
  "Dairy Products",
  "Demerol",
  "Depakote",
  "Detrol",
  "Diazepam",
  "Dicloxacillin",
  "Diflucan",
  "Digoxin",
  "Dilantin",
  "Dilaudid",
  "Diltiazem",
  "Dogs",
  "Doxycycline",
  "Dust",
  "Dye, Radiologic",
  "Eggs",
  "Ephedrine",
  "Epinephrine",
  "Erythromycin",
  "Ether",
  "Feathers",
  "Fentanyl",
  "Fish",
  "Flagyl",
  "Fosamax",
  "Fougera",
  "Fruit",
  "Garlic",
  "Gentamicin",
  "Glucagon",
  "Glucocorticoids",
  "Gluten",
  "Haldol",
  "Hazelnuts",
  "Hydrochlorothiazide",
  "Hydrocodone",
  "Ibuprofen",
  "Imipenem",
  "Influenza Vaccine",
  "Iodine",
  "Keflex",
  "Kiwi",
  "Lactose (Intolerance)",
  "Lamictal",
  "Lasix",
  "Latex",
  "Levaquin",
  "Librax",
  "Lidocaine",
  "Lipitor",
  "Lisinopril",
  "Lithium",
  "Lopid",
  "Lorazepam",
  "Macrobid",
  "Macrodantin",
  "Mercury",
  "Metaxalone",
  "Methotrexate",
  "Metronidazole",
  "Mexiletine",
  "Milk",
  "Minocin",
  "Mold",
  "Morphine",
  "Moxifloxacin",
  "Myambutol",
  "Mycobutin",
  "Nafcillin",
  "Namenda",
  "Naproxen",
  "Neosporin",
  "Niacin",
  "Nitrofurantoin Macrocrystals",
  "Nitroglycerin via IV",
  "No Known Allergies (NKA)",
  "Non Steroidal Anti Inflammatory Drugs (NSAIDS)",
  "Normal Saline",
  "Norvasc",
  "Nutmeg",
  "Nuts",
  "Oats",
  "Oxycodone",
  "Oxycontin",
  "Peanuts",
  "Penicillin",
  "Percocet",
  "Perfume",
  "Persantine",
  "Pet Dander",
  "Phenobarbitol",
  "Plavix",
  "Poison Oak",
  "Pollen",
  "Polyester",
  "Prednisone",
  "Premarin",
  "Prevacid",
  "Prilosec",
  "Propulsid",
  "Proton Pump Inhibitors",
  "Quinine Sulfate",
  "Quinolones",
  "Ragweed",
  "Raw Apples",
  "Red Meat",
  "Reglan",
  "Relafen",
  "Remeron",
  "Reminyl",
  "Risperdal",
  "Scallops",
  "Seafood",
  "Seasonal/ Hayfever",
  "Seldane",
  "Senna S",
  "Septra",
  "Serzone",
  "Shellfish",
  "Shrimp",
  "Simvastatin",
  "Skelaxin",
  "Smoke",
  "Soy",
  "Statins",
  "Stelazine",
  "Strawberries",
  "Sulfonamides (Sulfa Drugs)",
  "Sulphites",
  "Suprax",
  "Tegretol",
  "Terazosin",
  "Tetanus",
  "Tetracycline",
  "Thiosulfil",
  "Thorazine",
  "Tiazac",
  "Tomatoes",
  "Topamax",
  "Tramadol",
  "Tree Nuts",
  "Trimethoprim",
  "Trovan",
  "Ultram",
  "Vancomycin",
  "Vaseretic",
  "Vasotec",
  "Versed",
  "Vicodin",
  "Vioxx",
  "Voltaren",
  "Walnuts",
  "Wellbutrin",
  "Wheat",
  "Wine",
  "Zantac",
  "Zithromax",
  "Zoloft",
  "Zyprexa",
  "Zyvox",
];

export const legalTermsSchema = [
  {
    key: "nonSolicitation",
    title: "Non-Solicitation",
    fieldKey: "nonSolicitationTerm",
    description:
      "Client, Client’s representatives and agents (collectively, “Representative”), and each Responsible Party (as defined below) acknowledges, understands, and respects the relationship between Cambridge Caregivers and its employees. Client, and those acting on Client's behalf or on behalf of others, shall not directly or indirectly solicit, hire, or attempt to solicit or hire any person or entity employed by or contracted with Cambridge Caregivers, and shall not engage in any activity which is directed toward such an objective or result which would circumvent the Company's relationship with its employee. Client, Representative and each Responsible Party acknowledges that Cambridge Caregivers’ damages from the loss of its employee(s) may be difficult and expensive to establish; therefore, if Client solicits and hires, or in any manner attempts to solicit or hire, a Cambridge Caregiver's employee (or chooses to hire another firm representing the same employee) to work for Client, in any capacity, Client and each Responsible Party shall be responsible to pay to Cambridge Caregivers the amount of $20,000 per caregiver hired and, for professional caregivers (to include registered nurses, physician’s assistants, therapists, nutritionists, or other licensed professionals) $60,000 per professional caregiver hired, as liquidated damages, not as a penalty, and in addition to such other remedies that may be available to Cambridge Caregivers, including, without limitation, injunctive or other equitable relief and recovery of reasonable attorney's and/or collection fees.",
    agreementText: "Yes, I agree to the Non-Solicitation terms",
  },
  {
    key: "limitationOfLiability",
    title: "Limitation of Liability",
    fieldKey: "limitationOfLiabilityTerm",
    description:
      "Client, for itself and its Representative, each Responsible Party, and any other person or enterprise claiming hereunder, hereby acknowledges, understands, accepts, and agrees that Cambridge Caregivers shall not be liable or responsible for, and Client shall and does hereby waive, release and agree to indemnify and hold Cambridge, its liability, cost, damage, claims, suits, and/ or personal injury to Client or others arising in connection with the services provided by Cambridge Caregivers hereunder; Cambridge Caregivers hereby disclaims, and Client and each Responsible Party waives, and agrees not to rely upon (and shall not be entitled to rely upon), any express or implied warranties not set forth in this Agreement. The Client acknowledges and understands the natural consequences of aging, including but not limited to falls, wandering (elopements,) accidents or Client's refusal or non-compliance with physician's orders or the instructions, acts, or omissions of Cambridge Caregivers, including but not limited to medications, diet, physical activity, services or any other ordered therapy or treatment.",
    agreementText: "Yes, I agree to the Limitation of Liability terms",
  },
  {
    key: "arbitration",
    title: "Arbitration & Jury Trial Waiver",
    fieldKey: "arbitrationTerm",
    description:
      "All disputes regarding any aspect of this Engagement Agreement, including, without limitation, enforcement or interpretation of this Agreement, recovery of any amount due hereunder, or any claim for injury, harm or damage in any way associated  with any goods or services provided hereunder, shall be subject to determination by binding arbitration under the rules of the American Arbitration Association and any such arbitration shall be conducted in Dallas County, Texas, in accordance with Texas law, except for its conflicts of laws principles.  THE PARTIES HEREBY WAIVE AND AGREE NOT TO INVOKE ANY STATUTORY, CONSTITUTIONAL OR COMMON LAW RIGHT TO A TRIAL BY JURY REGARDLESS OF WHETHER SUCH RIGHT ARISES UNDER STATE OR FEDERAL LAW.",
    agreementText: "Yes, I agree to the Arbitration & Jury Trial Waiver terms",
  },
  {
    key: "consent",
    title: "Consent",
    fieldKey: "consentTerm",
    description:
      "Client or active MPOA or other Representative hereby give Cambridge Caregivers consent to use or disclose any protected health information to carry out Client's treatment, to obtain payment from insurance companies and for health care operations such as but not limited to quality reviews. Client or Representative further consent that protected health information may be received or released by Cambridge Caregivers by various means including but not limited to personal conversation, telephone, mail, email, or facsimile. Client or representative understands that they have the right to request a restriction of their protected health information used. However, they also understand that Cambridge Caregivers is not required to agree to this request. If Cambridge Caregivers agrees to the restriction the Company must abide by it. I, Client, or Representative have not requested a restriction of how my protected health information is used. Client or active MPOA understands that they may revoke this consent at any time by means of a request in writing, except for information already in use or disclosed.",
    agreementText: "Yes, I agree to the Consent terms",
  },
  {
    key: "billingPolicies",
    title: "Billing Policies",
    fieldKey: "billingPoliciesTerm",
    description:
      "By agreeing to the billing policies, Client and each Responsible Party acknowledge, accept, and agree to be bound by all terms related to payments, charges, and billing procedures outlined in the following sections and in the Overtime Agreement above, and to be financially responsible for all sums due and owing to Cambridge Caregivers hereunder.",
    agreementText: "Yes, I agree to the Billing Policies terms",
  },
  {
    key: "baseCharge",
    title: "Base Charge",
    fieldKey: "baseChargeTerm",
    description:
      "The Client and Responsible Party shall be responsible to pay a per-hour rate for Cambridge’s  services provided in accordance with this Engagement Agreement, which shall be due and payable on or before 10 days of the invoice date on each invoice. Any late payments are subject to a late fee equal to 15% of the past due amount for Cambridge’s anticipated internal costs associated with late payments. The Client, and each Responsible Party, agrees to pay Cambridge via Automated Clearing House (ACH,) credit card. Cambridge will not draft the Client's checking account without prior notice and authorization unless the invoice remains outstanding for more than 14 days after the invoice date or upon the passing of the Client. In either of these events, the Client and or each Responsible Party hereby authorizes and agrees to allow Cambridge to charge the payment against the Client's and or Responsible Party's banking account. Banking information (above) shall be kept current at all times applicable to this Engagement Agreement, and Client agrees Cambridge shall be entitled to, and that Client shall provide, an update thereof upon request by Cambridge.",
    agreementText: "Yes, I agree to the Base Charge terms",
  },
  {
    key: "overtimeAgreement",
    title: "Overtime Agreement",
    fieldKey: "overtimeAgreementTerm",
    description:
      "I acknowledge that Cambridge Caregivers will not schedule a caregiver to work more than forty (40) hours in any workweek unless expressly requested by me. If I request such scheduling, I agree to be financially responsible for payment of all applicable overtime wages and charges in accordance with federal, state, and local laws, in addition to any other obligations arising under this Agreement.",
    agreementText: "Yes, I agree to the Overtime Agreement terms",
  },
  {
    key: "cancellationFees",
    title: "Cancellation Fees",
    fieldKey: "cancellationFeesTerm",
    description:
      "Cambridge Caregivers understands that plans can change, and we strive to accommodate our clients accordingly. Nonetheless, if Client or Representative cancels a caregiver’s shift commitment within 24 hours of a particular shift's start time, Client will be charged for and responsible to pay the entirety of that shift. Furthermore, if caregivers or other staff members are sent home early, the Client or Responsible Party will be charged for the entire shift.",
    agreementText: "Yes, I agree to the Cancellation Fees terms",
  },
  {
    key: "holidaysAndOvertime",
    title: "Holidays and Overtime",
    fieldKey: "holidaysAndOvertimeTerm",
    description:
      "Client and each Responsible Party will be charged for and responsible to pay  for approved overtime for Cambridge Caregivers employees requested by or for the Client at Cambridge Caregivers’ overtime rates for those hours. Additionally, Cambridge Caregivers shall be entitled to charge, and Client and each Responsible Party shall be responsible to pay, holiday rates for hours worked on the following holidays: New Year’s Day, Memorial Day, July 4th, Labor Day, Veterans Day, Thanksgiving, and Christmas.",
    agreementText: "Yes, I agree to the Holidays and Overtime terms",
  },
  {
    key: "mileageReimbursement",
    title: "Mileage and Purchase Reimbursement",
    fieldKey: "mileageReimbursementTerm",
    description:
      "If the caregiver or other Cambridge Caregiver's employee transports the Client in the caregiver’s or other Cambridge Caregiver employee’s vehicle, the caregiver or other Cambridge Caregiver's employee will receive mileage reimbursement, and said reimbursement shall be billed to and paid by the Client and/or Responsible Party at the then-current IRS mileage reimbursement rate. Additionally, in the event that the caregiver or other Cambridge Caregiver's employee purchases items on behalf of the Client, the Client and Responsible Party(s) shall be responsible for the cost thereof (including taxes or other charges) and shall be billed accordingly.",
    agreementText:
      "Yes, I agree to the Mileage and Purchase Reimbursement terms",
  },
  {
    key: "lateCharges",
    title: "Late Charges",
    fieldKey: "lateChargesTerm",
    description:
      "Payment of invoices is considered “past due” if payment is not received by Cambridge within 14 days from the invoice date.  In addition to the late fee discussed above, interest will accrue on all past due amounts until they are paid in full, and Client and each Responsible Party shall be obligated to pay, and Cambridge Caregivers shall be entitled to collect, interest on any past due amounts at the maximum per annum interest rate permitted by law. Engagements 28 days in arrears are subject to immediate termination of this Agreement at the sole discretion of Cambridge Caregivers and may result in the collection and legal proceedings, none of which shall be deemed an election of remedies. The Client and each Responsible Party agrees to pay all costs of collection, including reasonable legal fees, court costs, or other legal expenses incurred by Cambridge Caregivers in connection with the collection of any and all amounts due and/or any action or proceeding to enforce or interpret the terms of this Agreement.",
    agreementText: "Yes, I agree to the Late Charges terms",
  },
  {
    key: "insurance",
    title: "Long Term Care Insurance",
    fieldKey: "insuranceTerm",
    description:
      "Although services may be covered by long-term care insurance, the Client or Responsible party is accountable for obtaining payments from their own insurance provider. The Client or Responsible party is fully financially responsible for paying Cambridge Caregivers upon receipt of the invoice from Cambridge, regardless of when the Client or Responsible party receives reimbursement from their long-term care provider.",
    agreementText: "Yes, I agree to the Insurance terms",
  },
  {
    key: "privacyConsent",
    title: "Privacy Consent",
    fieldKey: "privacyConsentTerm",
    description: null,
    agreementText: "Yes, I agree to the Privacy Consent terms",
  },
  {
    key: "obligationOfResponsibleParty",
    title: "Obligation of Responsible Party",
    fieldKey: "obligationOfResponsiblePartyTerm",
    description:
      "As the Responsible Party, I hereby agree to be absolutely, continuously, and personally liable to Cambridge for the prompt payment, performance and collection of the Client’s obligations as may later arise or become due under this Agreement if they are not timely paid when due hereunder by or on behalf of the Client.  Responsible Party acknowledges and agrees that Cambridge shall not be required to first sue, seek judgment against, or enforce Client’s obligations as against the Client, or to take any other steps as a condition of Cambridge’s enforcement of Responsible Party’s obligations hereunder, nor shall the failure of Cambridge to do so in any manner or amount limit, reduce or eliminate Responsible Party’s obligations hereunder.",
    agreementText: "Yes, I agree to the Responsible Party Obligation terms",
  },
  {
    key: "clientServicePlanAcknowledgement",
    title: "Client Participation in the Individual Service Plan",
    fieldKey: "clientServicePlanAcknowledgementFields",
    description:
      "By my signature below, (1) I acknowledge that I willingly participated in and advised the Agency representative in creating the Individual Service Plan in the electronic database, (2) I confirm that his ISP is accurate and complete based on the information I, my spouse, family, and/or my authorized representative provided to Cambridge Caregivers, (3) I understand that I must contact the Agency if I wish to make requests of its care staff that are not included in this ISP, (4) I authorize Cambridge Caregivers to provide assessment and/or care plan information to primary care physicians, home health agencies, hospices, and/or long term care insurance providers, and (5) changes can be made to the Individual Service Plan during the annual supervisory visit, or upon a client change in condition. I approve all updates and changes made to the Individual Service Plan by Agency for the duration of services.",
  },
];

export const requiredFieldsValidate = [
  { path: "formSubmissionDetails.city", label: "City", step: 1 },
  {
    path: "formSubmissionDetails.communityLiaison",
    label: "Community Liaison",
    step: 1,
  },
  {
    path: "formSubmissionDetails.isFillingForSomeoneElse",
    label: "Filling Fore Someone Else",
    step: 1,
  },
  { path: "formSubmissionDetails.email", label: "Email", step: 1 },
  {
    path: "formSubmissionDetails.referralSource",
    label: "Referral Source",
    step: 1,
  },
  {
    path: "formSubmissionDetails.fillersFirstName",
    label: "Fillter's First Name",
    step: 1,
  },
  {
    path: "formSubmissionDetails.fillersLastName",
    label: "Fillter's Last Name",
    step: 1,
  },
  {
    path: "formSubmissionDetails.fillersPhone",
    label: "Fillter's Phone No",
    step: 1,
  },

  { path: "clientInformation.firstName", label: "First Name", step: 1 },
  { path: "clientInformation.lastName", label: "Last Name", step: 1 },
  { path: "clientInformation.dateOfBirth", label: "Date Of Birth", step: 1 },
  { path: "clientInformation.gender", label: "Gender", step: 1 },
  { path: "clientInformation.heightFeet", label: "Height Feet", step: 1 },
  { path: "clientInformation.heightInches", label: "Height Inches", step: 1 },
  { path: "clientInformation.weight", label: "Weight", step: 1 },

  { path: "serviceDetails.startDate", label: "Start Date", step: 2 },
  {
    path: "serviceDetails.caregiverPreference",
    label: "Caregiver Preference",
    step: 2,
  },

  {
    path: "scheduleVariableFlexible.scheduleType",
    label: "Schedule Type",
    step: 2,
  },
  { path: "scheduleVariableFlexible.dayTimes", label: "Day Times", step: 2 },

  {
    path: "clientCareNeeds.medicalDiagnosis",
    label: "Medical Diagnosis",
    step: 3,
  },
  { path: "clientCareNeeds.fallRisk", label: "Fall Risk", step: 3 },
  { path: "clientCareNeeds.continence", label: "Continence", step: 3 },
  { path: "clientCareNeeds.vision", label: "Day TimesVision", step: 3 },
  { path: "clientCareNeeds.hearing", label: "Hearing", step: 3 },
  { path: "clientCareNeeds.speech", label: "Speech", step: 3 },
  {
    path: "clientCareNeeds.oxygenDependent",
    label: "Oxygen Dependent",
    step: 3,
  },
  {
    path: "clientCareNeeds.isShoweringAssistance",
    label: "Is Showering Assistance",
    step: 3,
  },
  {
    path: "clientCareNeeds.isMedicationReminders",
    label: "Is Medication Reminders",
    step: 3,
  },
  { path: "clientCareNeeds.swallowing", label: "Swallowing", step: 3 },
  { path: "clientCareNeeds.dental", label: "Dental", step: 3 },
  {
    path: "clientCareNeeds.isOralHygieneAssistance",
    label: "Is OralHygiene Assistance",
    step: 3,
  },
  {
    path: "clientCareNeeds.isMealtimeAssistance",
    label: "Is Mealtime Assistance",
    step: 3,
  },
  { path: "clientCareNeeds.walker", label: "Walker", step: 3 },

  {
    path: "serviceAddressSection0.serviceAddressStreet",
    label: "Address Street",
    step: 4,
  },
  {
    path: "serviceAddressSection0.serviceAddressCity",
    label: "Service Address City",
    step: 4,
  },
  {
    path: "serviceAddressSection0.serviceAddressState",
    label: "Service Address State",
    step: 4,
  },
  {
    path: "serviceAddressSection0.serviceAddressZipCode",
    label: "Service Address Zipcode",
    step: 4,
  },
  {
    path: "serviceAddressSection0.preferredPhone",
    label: "Preferred Phone",
    step: 4,
  },

  {
    path: "primaryCarePhysician.physicianFirstName",
    label: "Physician First Name",
    step: 5,
  },
  {
    path: "primaryCarePhysician.physicianLastName",
    label: "Physician Last Name",
    step: 5,
  },
  {
    path: "primaryCarePhysician.physicianPhoneNumber",
    label: "Physician Phone Number",
    step: 5,
  },

  { path: "signatureInfo.signature", label: "Signature", step: 5 },
  { path: "signatureInfo.NameOfSigner", label: "Name Of Signer", step: 5 },

  { path: "contacts.*.contactFirstName", label: "Contact First Name", step: 6 },
  { path: "contacts.*.contactLastName", label: "Contact Last Name", step: 6 },
  {
    path: "contacts.*.contactRelationship",
    label: "Contact Relationship",
    step: 6,
  },
  { path: "contacts.*.contactRoles", label: "Contact Roles", step: 6 },
  {
    path: "contacts.*.contactPhoneNumber",
    label: "Contact Phone Number",
    step: 6,
  },
  { path: "contacts.*.contactEmail", label: "Contact Email", step: 6 },

  {
    path: "emergencyPlanningSection0.stearRegistration",
    label: "Stear Registration",
    step: 7,
  },

  { path: "paymentDetailsSection0.baseRate", label: "Base Rate", step: 9 },
  {
    path: "paymentDetailsSection0.serviceType",
    label: "Service Type",
    step: 9,
  },
  {
    path: "paymentDetailsSection0.signatureInfo.signature",
    label: "Signature",
    step: 9,
  },
  {
    path: "paymentDetailsSection0.signatureInfo.NameOfSigner",
    label: "Name Of Signer",
    step: 9,
  },

  { path: "nonSolicitation", label: "Non Solicitation", step: 11 },
  { path: "limitationOfLiability", label: "Limitation Of Liability", step: 11 },
  { path: "arbitration", label: "Arbitration", step: 11 },
  { path: "consent", label: "Consent", step: 11 },
  { path: "billingPolicies", label: "Billing Policies", step: 11 },
  { path: "baseCharge", label: "Base Charge", step: 11 },
  { path: "cancellationFees", label: "Cancellation Fees", step: 11 },
  { path: "holidaysAndOvertime", label: "Holidays And Overtime", step: 11 },
  { path: "mileageReimbursement", label: "Mileage Reimbursement", step: 11 },
  { path: "lateCharges", label: "Late Charges", step: 11 },
  { path: "insurance", label: "Insurance", step: 11 },
  { path: "privacyConsent", label: "Privacy Consent", step: 11 },
  {
    path: "clientServicePlanAcknowledgement.clientServicePlanAcknowledgementFields.clientSignatureAndContactInfo.signatureOfClient",
    label: "Signature of Client or Client Contact",
    step: 11,
  },
  {
    path: "clientServicePlanAcknowledgement.clientServicePlanAcknowledgementFields.date",
    label: "Date",
    step: 11,
  },
  {
    path: "clientServicePlanAcknowledgement.clientServicePlanAcknowledgementFields.printedClientName",
    label: "Printed Name of Client/Client Contact",
    step: 11,
  },
];

export const PaymentTermsAndCondition = [
  {
    key: "paymentDetailsSection0",
    title: "Authorization to Transfer to Cambridge Caregivers, LLC",
    fieldKey: "bankDetails",
    paymentMethod: "bank",
    agreementKey: "authorizationToTransfer",
    description:
      "I hereby authorize Cambridge Caregivers, LLC to draw upon the above account for payment of obligations owed by Client under this Agreement, I authorize the above Depository Bank to approve transfers initiated by Cambridge Caregivers, LLC for payment on behalf of Client, and I agree to execute any additional documents as may be required by the Depository Bank for such authorization.",
    agreementText:
      "Yes, I agree to the Authorization to Transfer to Cambridge Caregivers, LLC",
  },
  {
    key: "paymentDetailsSection0",
    title: "Credit Card Processing Fee Acknowledgment",
    fieldKey: "creditCardDetails",
    paymentMethod: "credit",
    agreementKey: "feeAcknowledgment",
    description:
      "I acknowledge that I will pay a 5% recurring fee for using a credit card",
    agreementText:
      "Yes, I agree to the Credit Card Processing Fee Acknowledgment",
  },
];
